<template>
  <!-- Déjà affectée ailleurs : on ne bloque pas, on dit ce qu'elle quitte, et l'on confirme. -->
  <v-alert type="warning" outlined class="text-body-2">
    <div class="font-weight-bold mb-1">{{ $t('onboarding.field.reassignment.title') }}</div>
    <div v-if="reassignment.locationName">
      {{ $t('onboarding.field.reassignment.location', { location: reassignment.locationName, organization: reassignment.organizationName || '-' }) }}
    </div>
    <div v-if="reassignment.homeOfAnother">{{ $t('onboarding.field.reassignment.home') }}</div>
    <div v-if="reassignment.licences">{{ $tc('onboarding.field.reassignment.licences', reassignment.licences, { count: reassignment.licences }) }}</div>
    <div class="mt-2">{{ $t('onboarding.field.reassignment.risk') }}</div>
    <v-checkbox :input-value="value" hide-details class="mt-2" :label="$t('onboarding.field.reassignment.confirm')" @change="$emit('input', !!$event)" />
  </v-alert>
</template>

<script>
/**
 * La borne qu'on s'apprête à poser est déjà affectée (un dépôt, un autre site, le domicile d'un autre client, des
 * licences en cours) : on le dit, et la pose attend la confirmation. Confirmée, la mise en service la libère.
 */
export default {
  name: 'ReassignmentWarning',

  props: {
    reassignment: { type: Object, required: true },
    /** Confirmé. */
    value: { type: Boolean, default: false },
  },
}
</script>
